import askToArchiveContact from "../../../../modules/contacts/helpers/ask-to-archive-contact";

class archiveContact {
    constructor(Alert, $http, $state, $injector) {

        this.key = 'archive-contact';
        this.title = 'Archive';
        this.level = 'highlight';
        this.icon = 'fal fa-trash-alt';
        this.alert = Alert;
        this.api = $http;
        this.order = 110;
        this.state = $state;
        this.injector = $injector;
    }

    action(contact, vm) {

        askToArchiveContact(contact, this.injector).then(
            () => {
                this.state.reload();
                if (vm.store) {
                    return vm.store.dispatch('getData');
                }
            }
        );
    }
}

angular
    .module('festzelt-os.contacts')
    .factory('archiveContact', [
        'Alert',
        '$http',
        '$state',
        '$injector',
        (Alert, $http, $state, $injector) => new archiveContact(Alert, $http, $state, $injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/contacts/workflows/detailed-view/archive-contact.js